import { Typography } from '@euler/app/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo } from 'react';
import { View } from 'react-native';
import { useTheme } from 'styled-components';

export const ServiceSubjectSectionHeader = memo(
  ({ title, count }: { title: string; count?: number }) => {
    const { rpx } = useResponsiveContext();
    const {
      construction: {
        schedule: {
          workItem: {
            listSection: { bgColor, titleColor },
          },
        },
      },
    } = useTheme();
    const countLabel = count != null ? ` (${count}项)` : '';
    return (
      <View
        css={`
          padding: ${rpx(15)}px ${rpx(25)}px;
          background-color: ${bgColor};
        `}
      >
        <Typography.Label
          bold
          size={rpx(16)}
          css={`
            color: ${titleColor};
          `}
        >{`${title}${countLabel}`}</Typography.Label>
      </View>
    );
  },
);
